<template>
  <div class="page-content">
    <AnalyticsComponent />
  </div>
</template>

<script>
import AnalyticsComponent from '../components/AnalyticsComponent.vue'

export default {
  name: 'Analytics',
  components: {
    AnalyticsComponent
  }
}
</script>

<style scoped>
.page-content {
  flex: 1;
  display: flex;
  width: 100%;
  height: 100%;
  position: relative;
}
</style>
